import { inject, Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, skip, take } from 'rxjs/operators';
import { NoteTagsService } from '../services/note-tags.service';
import { AuthorizationService } from '../../hateoas/authorization.service';

@Injectable({
    providedIn: 'root',
})
export class NoteCharacteristicAuthGuard {
    readonly http = inject(HttpClient);
    private readonly noteTagsService = inject(NoteTagsService);

    canActivate(): Observable<boolean> {
        this.noteTagsService.init();
        return this.noteTagsService.characteristic$.pipe(
            skip(1),
            take(1),
            map((it) => AuthorizationService.isAuthorized(it, 'self', 'read')),
        );
    }
}
